<div>
  <!-- <pre>{{page | json}}</pre> -->
  <mat-paginator class="pagination-alignment border rounded-3" #Paginator
                  (page)="pageEvent($event)"
                  [length]="totalCount"
                  [pageSize]="20"
                  aria-label="Select page">
            </mat-paginator>
</div>
<!-- <mat-paginator class="pagination-alignment border rounded-3" #paginator [length]="totalCount"
[pageSize]="20" [pageSizeOptions]="pageSizeOptions"
[showFirstLastButtons]="showFirstLastButtons" (page)="pageEvent($event)" aria-label="Select page">
</mat-paginator> -->
